import React from "react";
import PropTypes from "prop-types";
import { handleEnterSpaceKey } from "utils";

//FIXME: SOF-617 requires the following imports to be moved to components/widget-components.scss
// due to lazy loading of the widget inside an iframe. Keeping this here for potential fix down the road.
// import 'components/questions/FlexMatrixQuestionRow.scss';

const FlexMatrixQuestionRow = ({ rowId, row, columns, onOptionSelected, isDisabled }) => {
  const { text, options } = row;
  const textId = `${rowId}-text`;

  const handleOnChange = (changedOption) => {
    if (isDisabled) {
      return;
    }
    return onOptionSelected(changedOption, row);
  };

  const handleOnKeyUp = (event, changedOption) => {
    if (isDisabled) {
      return;
    }
    return handleEnterSpaceKey(event, () => onOptionSelected(changedOption, row));
  };

  return (
    <div className="csw-q-flex-mtrx-row" id={rowId}>
      <div className="csw-q-flex-mtrx-row-title" role="heading" aria-level="2" id={textId}>
        {text}
      </div>
      <ul className="csw-q-flex-mtrx-o-list csw-option-list" role="radiogroup" aria-labelledby={textId}>
        {options &&
          options.map((optionDetail, index) => {
            const { id, text, selected } = optionDetail;
            const mtrxOptId = `csw-q-o-${rowId}-${id}`;
            const mtrxKey = `${mtrxOptId}-${index}`;
            const column = columns[index];
            const { text: labelText } = column;

            return (
              <li
                className="csw-q-flex-mtrx-o"
                key={mtrxKey}
                role="radio"
                aria-checked={selected}
                aria-labelledby={`${mtrxOptId}-lbl`}
              >
                <input
                  className="csw-q-flex-mtrx-rdo-input sr-only outline-trigger"
                  type="radio"
                  id={mtrxOptId}
                  name={rowId}
                  value={text}
                  defaultChecked={selected}
                  onChange={() => handleOnChange(optionDetail)}
                  disabled={isDisabled}
                  onKeyUp={(event) => handleOnKeyUp(event, optionDetail)}
                  tabIndex="3"
                />
                <label
                  className="csw-q-flex-mtrx-lbl outline"
                  id={`${mtrxOptId}-lbl`}
                  htmlFor={mtrxOptId}
                  onKeyUp={(event) => handleOnKeyUp(event, optionDetail)}
                  tabIndex="0"
                  aria-label={text}
                  aria-disabled={isDisabled}
                >
                  <span className="csw-q-flex-mtrx-chk csw-option-check-border" aria-hidden="true">
                    {" "}
                  </span>
                  <span className="csw-q-flex-mtrx-txt">{labelText}</span>
                </label>
              </li>
            );
          })}
      </ul>
    </div>
  );
};

FlexMatrixQuestionRow.propTypes /* remove-proptypes */ = {
  rowId: PropTypes.string.isRequired,
  row: PropTypes.object,
  columns: PropTypes.array,
  onOptionSelected: PropTypes.func,
  isDisabled: PropTypes.bool,
};

export default FlexMatrixQuestionRow;
